import React from "react";
import Lottie from "lottie-react";
import animationData from "../assets/success.json";
import { Button } from "@/components/ui/button";
import { buttonVariants } from "@/components/ui/button";
import { Link } from "react-router-dom";

const OrderSuccess = () => {
  return (
    <div>
      <div className="pl-10 flex ml-10 items-center justify-center">
        <div className="w-48">
          <Lottie animationData={animationData} />
        </div>
        <div className="flex-none text-md">Order Success</div>
      </div>
      <div className="pl-10 flex ml-10 items-center justify-center">
        <Button asChild>
          <Link to="/orders">View Orders</Link>
        </Button>
      </div>
    </div>
  );
};

export default OrderSuccess;
